/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { EnergyDemand } from "./modelEnergyDemand";

class ControllerEnergyDemand extends ControllerModel {
    constructor() {
        super("ControllerEnergyDemand");

        this.setNewNode = (callback) => {
            let energyDemand = new EnergyDemand();
            energyDemand.decorate(callback);

            this.addNode(energyDemand);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let energyDemand = new EnergyDemand();
            energyDemand.copyFrom(node);
            energyDemand.decorate(callback);
            this.addNode(energyDemand)
        }

        this.getProperties = async (node) => {
            let n = new EnergyDemand();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new EnergyDemand();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerEnergyDemand };